import React from 'react'
import { useTranslation } from 'react-i18next'

const Navbar = ({title}) => {
const { t: trans, i18n } = useTranslation(['mobileCommon', 'test'])
  return (
    <section className="cart  h-full  ">
        <div className=" p-10 bg-black text-white">
          <div className="sales-header">
                  <img src="/assets/logo/white_logo_small_size.svg" alt="discount" className="" />

            <h2 className="text-40 py-5 text-white text-center font-bold nice-apply-theme text-capitalize">
              {title}
            </h2>

            <div
              className={'change-lang text-bold text-24'}
              onClick={() => {
                var bb =
                  window.location.pathname.includes('/en') ||
                  window.location.pathname.includes('/ar')
                    ? window.location.href.replace(
                        /en|ar/,
                        trans('mobileCommon:changeLangCode'),
                      )
                    : window.location.origin +
                      '/' +
                      trans('mobileCommon:changeLangCode') +
                      window.location.pathname
                window.location = bb
              }}
            >
              {trans('mobileCommon:changeLang')}
            </div>
          </div>
        </div>
      </section>
  )
}

export default Navbar